import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
// import { ScriptLoaderService } from '../_services/script-loader.service';
import { ActivatedRoute, Params } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { environment } from '../../environments/environment';
import { Helpers } from '../helpers';
import { PrintFormatsComponent } from '../print-formats/print-formats.component';
import { TranslateConfigService } from '../theme/home/translateConfig.service';
import { appService } from '../_services/app.service';
import { CommonService } from "../_services/common.service";
// declare var $: any;
import * as $ from "jquery";
const LNG_KEY = "SELECTED_LANGUAGE";

@Component({
  selector: 'app-print-invoice',
  templateUrl: './print-invoice.component.html',
  styleUrls: ['./print-invoice.component.scss']
})
export class PrintInvoiceComponent implements OnInit, AfterViewInit {

  PrintData: any = [];
  PrintDataModal: any = {};
  RoundOfAmount: any = 0;
  InvoiceId: string = '';
  imgPath: any;
  SelectedComapnyName: any;
  SelectedCompanyAdd: any;
  SelectedCompanyCIN: any;
  SelectedCompantGSTIN: any;
  SelectedCompanyLogo: any;
  SelectedCompanyPAN: any
  SelectedCompantEmail: any;
  SelectedCompanyWebsite: any;
  CompanyId: any;
  InvoiceType: string = '';
  IsOutstandingStatement: string = 'False';
  selectedLang: string;
  hostURL = environment.apiUrl;
  TenantUsers: any;
  CompanyIdForCookie: any;
  isInternational: boolean = false;
  CustomMessage: string = 'Please wait till we load the invoice..';
  hostUrl: any = environment.apiUrl;

  //added by vithujan 19-01-2023
  isShowPrintSummary: boolean = false;
  isSummary_FixedKM: boolean = false;
  isDetail: boolean = false;
  isDetail1: boolean = false;
  isPDF_EInvoice: boolean = false;
  isDetail1OnLatterPad: boolean = false;
  isOnLatterPad_EInvoice: boolean = false;
  isDetail_KM_MT: boolean = false;
  PrintInvoiceInfinity: boolean = false;
  isUBInvoice: boolean = false;
  isPrintInvoiceKSHSummary: boolean = false;
  @ViewChild(PrintFormatsComponent) PrintFormatsChild: PrintFormatsComponent;
  TaxApplicableFlag: boolean = false;
  SelectedCompanyLogoImg: any;
  isShowInvoice: boolean = false;
  isShowPaymentMade: boolean = false;
  selectedOption: string = 'Invoice';
  ReceiptSummaryData: any = [];
  //end
  invPodListData: any = [];
  OutstandingData: any = [];
  TotalInvoiceAmount: any = 0;
  TotalReceiptAmount: any = 0;
  TotalClosingBalance: any = 0;
  whitelabelFlag: boolean = false;
  isISAUrl: any = environment.apiUrl == 'https://isa.ifreightbox.net/' ? true : false;
  //added by vithujan 31-08-2023
  isQuotationPrint: boolean = false;
  InvoiceData: any = [];
  QuoteCompanyData: any;
  QuoteUserData: any;
  UserId: any;
  QuoteNo: any;
  isNCCUrl: any = environment.apiUrl == 'https://ncc.ifreightbox.net/' ? true : false;
  @ViewChild('invoiceBody') invoiceBody: ElementRef = null;
  invoiceHtml: any;

  constructor(
    private service: TranslateConfigService,
    // private _script: ScriptLoaderService,
    private translate: TranslateService,
    private toastr: ToastrService,
    private _appService: appService,
    private _activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private commonService: CommonService
  ) {
    if (this.hostURL == 'https://nol.ifreightbox.net/') {
      let language = 'en';
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage('en');
        this.selectedLang = 'en';
      }
      let val = localStorage.getItem(LNG_KEY);
    }
    else {
      let language = 'en';
      let value = localStorage.getItem(LNG_KEY);
      if (value === "" || value === null || value === undefined) {
        this.translate.setDefaultLang(language);
        this.selectedLang = language;
      } else {
        this.service.setLanguage('en');
        this.selectedLang = 'en';
      }
      let val = localStorage.getItem(LNG_KEY);
    }
  }

  ngOnInit() {
    // this._script
    //   .loadScripts(
    //     "body",
    //     [
    //       "assets/vendors/base/vendors.bundle.js",
    //       "assets/demo/default/base/scripts.bundle.js"
    //     ],
    //     true
    //   )
    //   .then(() => {
    this.GetSalesFlag();
    this.LoadTaxApplicable();

    this._activatedRoute.params.subscribe((params: Params) => {
      this.InvoiceId = this._activatedRoute.snapshot.queryParams["invoice"];
      this.InvoiceType = this._activatedRoute.snapshot.queryParams["type"];
      this.IsOutstandingStatement = this._activatedRoute.snapshot.queryParams["IsOutstandingStatement"];

      if (this.InvoiceId !== undefined && this.InvoiceId !== null && this.InvoiceType !== undefined && this.InvoiceType !== null) {
        if (this.InvoiceType == 'PrintQuote') {
          this.isQuotationPrint = true;
          this.GetOrderData(this.InvoiceId);
          setTimeout(() => {
            this.GetUserCompanyByOrder(this.InvoiceId);
            this.ShowQuoteData(this.InvoiceId);
          }, 1000);
        } else {
          this.GetUserCompany(this.InvoiceId);
          setTimeout(() => {
            this.GetPrintData(this.InvoiceType, 'Show');
            this.UpdateIsViewed(this.InvoiceId);
            this.GetPaymentSummaryData();
          }, 1000);
        }
      }
    });
    this.GetWhiteLabelSettingVal();
    // });
  }

  ngAfterViewInit() {
    // Wait for the view to initialize and the DOM to be rendered
  }

  PrintBill() {
    this.GetPrintData(this.InvoiceType, 'Print');
    console.log('this.PrintData', this.PrintData);

  }

  GetSalesFlag() {
    var apiUrl = environment.apiUrl + "api/OrdersByVehicle/GetTaxServiceSetting";

    this.http.get(apiUrl).subscribe((res) => {
      const value = JSON.stringify(res);
      this.isInternational = this.getBoolean(value);
    },
      (err) => {
        console.log(err);
      }); // ends here
  }

  LoadTaxApplicable() {
    var apiUrl = environment.apiUrl + "api/Common/GetSystemSettingByName/IsTaxApplicable";

    this.http.get(apiUrl).subscribe(
      (response) => {
        if (response == '1') {
          this.TaxApplicableFlag = true;
        } else {
          this.TaxApplicableFlag = false;
        }
      },
      (err) => {
        this.toastr.error(
          "Error occurred while fetching Status data !",
          "error"
        );
      }
    );
  }

  getBoolean(value) {
    switch (value) {
      case true:
      case "true":
      case 1:
      case "1":
      case "on":
      case "yes":
        return true;
      default:
        return false;
    }
  }

  GetUserCompany(id: string) {

    // var apiUrl = environment.apiUrl + "api/Company/GetUserCompanyDataByInvoice/" + id;
    var apiUrl = environment.apiUrl + "api/Company/GetUserCompanyDataByInvoice?id=" + id + "&param1=InvoiceId";
    this.http.get(apiUrl).subscribe(
      (response: any) => {
        this.TenantUsers = response.data;
        this.TenantUsers.forEach((element) => {
          this.CompanyIdForCookie = element;
          this.CompanyId = this.CompanyIdForCookie.Id;
          this.SelectedComapnyName = this.CompanyIdForCookie.SelectedComapnyName;
          this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
          this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
          this.SelectedCompantGSTIN = this.CompanyIdForCookie.SelectedCompantGSTIN;
          this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
          this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
          this.SelectedCompantEmail = this.CompanyIdForCookie.SelectedComapnyEmail;
          this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
          this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
          this.SelectedCompanyLogoImg = environment.apiUrl + this.SelectedCompanyLogo;
        });
      },
      (err) => {
        console.log(err);
        console.log("Error occured");
      }
    );
  }

  GetPrintData(Type, ToDo) {

    Helpers.setLoading(true);
    this.PrintDataModal.InvoiceId = this.InvoiceId;
    if (Type == 'Detail1OnLatterPad' || Type == 'PDF_EInvoice' || Type == 'OnLatterPad_EInvoice') {
      this.PrintDataModal.Type = 'Detail1';
    } else {
      this.PrintDataModal.Type = Type;
    }
    if (Type == 'PrintInvoiceKSH' || Type == 'PrintInvoiceKSHSummary' || Type == 'PrintInvoiceAnnexureformatGeneralKSH' || Type == 'PrintInvoiceAnnexureMR4Movement') {

      var apiUrl = environment.apiUrl + "api/Sales/GetPrintDataKSH";
      this.http.post(apiUrl, this.PrintDataModal).subscribe((response) => {
        this.PrintData = response;
        for (var i = 0; i < this.PrintData.length; i++) {
          let SGST: any = 0.0;
          let CGST: any = 0.0;
          let IGST: any = 0.0;
          this.PrintData[i].TotalQty = 0;
          this.PrintData[i].TotalDiscount = 0;
          this.PrintData[i].TotalAmount = 0;
          this.PrintData[i].NetTotalAmount = 0;
          this.PrintData[i].RoundOffValue = 0;
          this.PrintData[i].TotalCGST = 0;
          this.PrintData[i].TotalSGST = 0;
          this.PrintData[i].TotalIGST = 0;
          let UBSrNo = 1;
          this.PrintData[i].InvoiceDetails.forEach((element) => {
            //-----for Ub only------------
            if (Type == "AllInOne") {
              if (element.Unit == "Day") {
                element.SrNo = UBSrNo;
                UBSrNo++;
              }
            }
            //----------------------------
            if (
              element.Discount == null ||
              element.Discount == undefined ||
              element.Discount == ""
            ) {
              element.Discount = 0;
            }
            if (this.PrintData[i].IsTaxable == true) {
              if (element.CGST != null && element.CGST != 0) {
                CGST = element.Amount * (element.CGST / 100);
              }
              if (element.SGST != null && element.SGST != 0) {
                SGST = element.Amount * (element.SGST / 100);
              }
              if (element.IGST != null && element.IGST != 0) {
                IGST = element.Amount * (element.IGST / 100);
              }
            } else {
              element.ChargedGST = "NA";
            }
            this.PrintData[i].TotalAmount += element.Amount;
            this.PrintData[i].TotalDiscount += element.Discount;
            this.PrintData[i].TotalQty += element.Quantity;
            this.PrintData[i].TotalQty = Math.round(this.PrintData[i].TotalQty * 100) / 100;
            this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));
            this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));
            this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));
            CGST = 0.0;
            SGST = 0.0;
            IGST = 0.0;
            if (this.PrintData[i].ChargeType == 'Credit Note') {
              element.Amount = element.Amount * -1;
            }
          });
          this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));
          this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));
          this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));
          this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));
          //added by vithujan 13-10-2022
          if (this.TaxApplicableFlag == true) {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount + this.PrintData[i].TotalCGST + this.PrintData[i].TotalSGST + this.PrintData[i].TotalIGST;
          } else {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount;
          }
          //end
          this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));
          // add kevin 12-Jan-2022
          this.RoundOfAmount = parseFloat((Math.round(this.PrintData[i].NetTotalAmount) - this.PrintData[i].NetTotalAmount).toFixed(2));
          this.PrintData[i].NetTotalAmount = Math.round(this.PrintData[i].NetTotalAmount);
          this.PrintData[i].RoundOffValue = this.RoundOfAmount;
          // end
          // add kevin 02-Mar-2022
          if (this.PrintData[i].ChargeType == 'Credit Note') {
            this.PrintData[i].TotalAmount = this.PrintData[i].TotalAmount * -1;
            this.PrintData[i].NetTotalAmount = this.PrintData[i].NetTotalAmount * -1;
            this.PrintData[i].TotalCGST = this.PrintData[i].TotalCGST * -1;
            this.PrintData[i].TotalSGST = this.PrintData[i].TotalSGST * -1;
            this.PrintData[i].TotalIGST = this.PrintData[i].TotalIGST * -1;
            this.PrintData[i].RoundOffValue = this.PrintData[i].RoundOffValue * -1;
          }
          // end
          this.PrintData[i].TotalTaxablevalue = 0;
          this.PrintData[i].ComponentToTalIGST = 0;
          this.PrintData[i].ComponentToTalSGST = 0;
          this.PrintData[i].ComponentToTalCGST = 0;
          this.PrintData[i].ComponentToTalGST = 0;
          if (Type != "AllInOne") {
            this.PrintData[i].ComponentRate.forEach((element) => {
              element.ComponentGST = 0;
              if (this.PrintData[i].IsTaxable != true) {
                element.IntegratedGST = 0;
                element.StateGST = 0;
                element.CentralGST = 0;
                element.IGSTRATE = 0;
                element.SGSTRATE = 0;
                element.CGSTRATE = 0;
              }
              this.PrintData[i].TotalTaxablevalue += element.TaxableValue;
              this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;
              this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;
              this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;
              element.ComponentGST += element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;
              // add kevin 02-Mar-2022
              if (this.PrintData[i].ChargeType == 'Credit Note') {
                element.TaxableValue = element.TaxableValue * -1;
                element.IGSTRATE = element.IGSTRATE * -1;
                element.SGSTRATE = element.SGSTRATE * -1;
                element.CGSTRATE = element.CGSTRATE * -1;
                element.ComponentGST = element.ComponentGST * -1;
                this.PrintData[i].TotalTaxablevalue = this.PrintData[i].TotalTaxablevalue * -1;
                this.PrintData[i].ComponentToTalIGST = this.PrintData[i].ComponentToTalIGST * -1;
                this.PrintData[i].ComponentToTalSGST = this.PrintData[i].ComponentToTalSGST * -1;
                this.PrintData[i].ComponentToTalCGST = this.PrintData[i].ComponentToTalCGST * -1;
              }
              // end
            });
            this.PrintData[i].ComponentToTalGST = this.PrintData[i].ComponentToTalIGST + this.PrintData[i].ComponentToTalSGST + this.PrintData[i].ComponentToTalCGST;
          } else {
            this.PrintData[i].TotalDamage = 0;
            this.PrintData[i].TotalShortage = 0;
            this.PrintData[i].TotalSealShort = 0;
            this.PrintData[i].TotalGoodQtyBoxes = 0;
            this.PrintData[i].TotalGoodQtyBottles = 0;
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              //--------------------Bottles---------------------
              let TotalBottles = element.Quantity * 12;
              let TotalGoodBottles = TotalBottles - (element.Damage + element.Shortage + element.SealShort);
              let TotalGoodQuantityBoxes: number = 0;
              TotalGoodQuantityBoxes = TotalGoodBottles % 12;
              element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;
              //--------------------Boxes-----------------------
              let DamageBoxes = Math.floor(TotalGoodBottles / 12);
              element.TotalGoodQuantityBoxes = DamageBoxes;
              //----------------------Total---------------------
              this.PrintData[i].TotalDamage = this.PrintData[i].TotalDamage + element.Damage;
              this.PrintData[i].TotalShortage = this.PrintData[i].TotalShortage + element.Shortage;
              this.PrintData[i].TotalSealShort = this.PrintData[i].TotalSealShort + element.SealShort;
              this.PrintData[i].TotalGoodQtyBoxes = this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;
              this.PrintData[i].TotalGoodQtyBottles = this.PrintData[i].TotalGoodQtyBottles + element.TotalGoodQuantityBottles;
            });
          }
          if (Type == "AllInOne") {
            this.PrintData[i].TotalHaltingAmount = 0.0;
            this.PrintData[i].TotalProductQuantity = 0;
            this.PrintData[i].InvoiceDetails.forEach((element) => {
              if (element.Unit == "Day") {
                this.PrintData[i].TotalHaltingAmount =
                  this.PrintData[i].TotalHaltingAmount + element.Amount;
              }
            });
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              this.PrintData[i].TotalProductQuantity = this.PrintData[i].TotalProductQuantity + element.Quantity
            });
          }
        }
        if (this.InvoiceType == "Summary" && this.isISAUrl == true) {
          for (var i = 0; i < this.PrintData.length; i++) {
            this.PrintData[i].InvoiceDetails.sort(function (a, b) {
              var ChargedGSTA = a.ChargedGST ? a.ChargedGST : '';
              var ChargedGSTB = b.ChargedGST ? b.ChargedGST : '';
              return ChargedGSTA.localeCompare(ChargedGSTB);
            });

            this.PrintData[i].InvoiceDetailsA = [];
            this.PrintData[i].InvoiceDetailsB = [];
            this.PrintData[i].Charges = [];

            this.PrintData[i].InvoiceDetails.forEach(element => {
              if (element.ChargedGST == 'NA') {
                var isDone: any = false;
                this.PrintData[i].InvoiceDetailsB.forEach(elementD => {
                  if (element.ChargeType == elementD.ChargeType
                    && element.SACCODE == elementD.SACCODE
                    && element.ChargedGST == elementD.ChargedGST
                    && element.ToCity == elementD.ToCity
                    && element.Unit == elementD.Unit
                    && element.Rate == elementD.Rate) {
                    isDone = true;
                    elementD.QuantityA = parseFloat((elementD.QuantityA + element.Quantity).toFixed(2));
                    elementD.DiscountA = parseFloat((elementD.DiscountA + element.Discount).toFixed(2));
                    elementD.AmountA = parseFloat((elementD.AmountA + element.Amount).toFixed(2));
                  }
                });
                if (isDone == false) {
                  var objA: any = {};
                  objA = element;
                  objA.QuantityA = element.Quantity;
                  objA.RateA = element.Rate;
                  objA.DiscountA = element.Discount;
                  objA.AmountA = element.Amount;
                  this.PrintData[i].InvoiceDetailsB.push(objA);
                }
              } else {
                var isDone: any = false;
                this.PrintData[i].InvoiceDetailsA.forEach(elementD => {
                  if (element.ChargeType == elementD.ChargeType
                    && element.SACCODE == elementD.SACCODE
                    && element.ChargedGST == elementD.ChargedGST
                    && element.ToCity == elementD.ToCity
                    && element.Unit == elementD.Unit
                    && element.Rate == elementD.Rate) {
                    isDone = true;
                    elementD.QuantityA = parseFloat((elementD.QuantityA + element.Quantity).toFixed(2));
                    elementD.DiscountA = parseFloat((elementD.DiscountA + element.Discount).toFixed(2));
                    elementD.AmountA = parseFloat((elementD.AmountA + element.Amount).toFixed(2));
                  }
                });
                if (isDone == false) {
                  var objA: any = {};
                  objA = element;
                  objA.QuantityA = element.Quantity;
                  objA.RateA = element.Rate;
                  objA.DiscountA = element.Discount;
                  objA.AmountA = element.Amount;
                  this.PrintData[i].InvoiceDetailsA.push(objA);
                }
              }

              var data = this.PrintData[i].Charges.filter(x => x.Name === element.ChargeType);
              if (data.length <= 0) {
                var obj: any = {};
                obj.Name = element.ChargeType;
                obj.Amount = 0;
                this.PrintData[i].Charges.push(obj);
              }
            });

            this.PrintData[i].Charges.forEach(element => {
              var data = this.PrintData[i].InvoiceDetails.filter(x => x.ChargeType === element.Name);
              if (data.length > 0) {
                var totalAmount = 0;
                for (let index = 0; index < data.length; index++) {
                  totalAmount = (totalAmount + data[index].Amount)
                }
                element.Amount = totalAmount;
              }
            });
          }
        }

        if (this.InvoiceType == "Detail" && this.isISAUrl == true) {
          for (var i = 0; i < this.PrintData.length; i++) {
            this.PrintData[i].InvoiceDetails.sort(function (a, b) {
              var ChargedGSTA = a.ChargedGST ? a.ChargedGST : '';
              var ChargedGSTB = b.ChargedGST ? b.ChargedGST : '';
              return ChargedGSTA.localeCompare(ChargedGSTB);
            });

            this.PrintData[i].InvoiceDetailsA = [];
            this.PrintData[i].InvoiceDetailsB = [];
            this.PrintData[i].Charges = [];

            this.PrintData[i].InvoiceDetails.forEach(element => {
              if (element.ChargedGST == 'NA') {
                this.PrintData[i].InvoiceDetailsB.push(element);
              } else {
                this.PrintData[i].InvoiceDetailsA.push(element);
              }

              var data = this.PrintData[i].Charges.filter(x => x.Name === element.ChargeCode);
              if (data.length <= 0) {
                var obj: any = {};
                obj.Name = element.ChargeCode;
                obj.Amount = 0;
                this.PrintData[i].Charges.push(obj);
              }
            });

            this.PrintData[i].Charges.forEach(element => {
              var data = this.PrintData[i].InvoiceDetails.filter(x => x.ChargeCode === element.Name);
              if (data.length > 0) {
                var totalAmount = 0;
                for (let index = 0; index < data.length; index++) {
                  totalAmount = (totalAmount + data[index].Amount)
                }
                element.Amount = totalAmount;
              }
            });
          }
        }
        if (ToDo == "Print") {
          this.PrintFormatsChild.InvoiceId = this.InvoiceId;
          this.PrintFormatsChild.PrintData = this.PrintData;
          this.PrintFormatsChild.InvoiceType = Type;
          this.PrintFormatsChild.PrintInvoice();
        }
        if (ToDo == "Show") {
          setTimeout(() => {
            if (this.InvoiceType == "Summary") {
              this.isShowPrintSummary = true;
            } else if (this.InvoiceType == "Summary_FixedKM") {
              this.isSummary_FixedKM = true;
            } else if (this.InvoiceType == "Detail") {
              this.isDetail = true;
            } else if (this.InvoiceType == "Detail1") {
              this.isDetail1 = true;
            } else if (this.InvoiceType == "PDF_EInvoice") {
              this.isPDF_EInvoice = true;
            } else if (this.InvoiceType == "Detail1OnLatterPad") {
              this.isDetail1OnLatterPad = true;
            } else if (this.InvoiceType == "OnLatterPad_EInvoice") {
              this.isOnLatterPad_EInvoice = true;
            } else if (this.InvoiceType == "Detail_KM_MT") {
              this.isDetail_KM_MT = true;
            } else if (this.InvoiceType == "PrintInvoiceKSHSummary") {
              this.isPrintInvoiceKSHSummary = true;
            } else if (this.InvoiceType == "PrintInvoiceInfinity") {
              this.PrintInvoiceInfinity = true;
            }
            else {
              this.isUBInvoice = true;
            }

            setTimeout(() => {
              if (this.invoiceBody) {
                this.invoiceHtml = this.invoiceBody.nativeElement.innerHTML;
                this.getInvoiceConsignmentPODList();
                console.log(this.invoiceHtml);
              }
            }, 5000);
          }, 500);
          Helpers.setLoading(false);
        }
        this.GetOutstandingStatement();
      },
        (err) => {
          Helpers.setLoading(false);
          $("#PrintInvoice").val("");
          this.toastr.error("An error occured printing !", "error");
        }
      );
    } else {
      var apiUrl = environment.apiUrl + "api/Sales/GetPrintData";
      this.http.post(apiUrl, this.PrintDataModal).subscribe((response) => {
        this.PrintData = response;
        for (var i = 0; i < this.PrintData.length; i++) {
          let SGST: any = 0.0;
          let CGST: any = 0.0;
          let IGST: any = 0.0;
          this.PrintData[i].TotalQty = 0;
          this.PrintData[i].TotalDiscount = 0;
          this.PrintData[i].TotalAmount = 0;
          this.PrintData[i].NetTotalAmount = 0;
          this.PrintData[i].RoundOffValue = 0;
          this.PrintData[i].TotalCGST = 0;
          this.PrintData[i].TotalSGST = 0;
          this.PrintData[i].TotalIGST = 0;
          let UBSrNo = 1;
          this.PrintData[i].InvoiceDetails.forEach((element) => {
            //-----for Ub only------------
            if (Type == "AllInOne") {
              if (element.Unit == "Day") {
                element.SrNo = UBSrNo;
                UBSrNo++;
              }
            }
            //----------------------------
            if (
              element.Discount == null ||
              element.Discount == undefined ||
              element.Discount == ""
            ) {
              element.Discount = 0;
            }
            if (this.PrintData[i].IsTaxable == true) {
              if (element.CGST != null && element.CGST != 0) {
                CGST = element.Amount * (element.CGST / 100);
              }
              if (element.SGST != null && element.SGST != 0) {
                SGST = element.Amount * (element.SGST / 100);
              }
              if (element.IGST != null && element.IGST != 0) {
                IGST = element.Amount * (element.IGST / 100);
              }
            } else {
              element.ChargedGST = "NA";
            }
            this.PrintData[i].TotalAmount += element.Amount;
            this.PrintData[i].TotalDiscount += element.Discount;
            this.PrintData[i].TotalQty += element.Quantity;
            this.PrintData[i].TotalQty = Math.round(this.PrintData[i].TotalQty * 100) / 100;
            this.PrintData[i].TotalCGST += parseFloat(CGST.toFixed(2));
            this.PrintData[i].TotalSGST += parseFloat(SGST.toFixed(2));
            this.PrintData[i].TotalIGST += parseFloat(IGST.toFixed(2));
            CGST = 0.0;
            SGST = 0.0;
            IGST = 0.0;
            // if (this.PrintData[i].ChargeType == 'Credit Note') {
            //   element.Amount = element.Amount * -1;
            // }

            if (this.hostUrl == 'http://tms.theptpl.com/') {
              if (element.ReferenceNo != null && element.ReferenceNo != '') {
                element.ReferenceNo = element.ReferenceNo.split('/SealNo')[0];
              }
            }
          });
          this.PrintData[i].TotalAmount = parseFloat(this.PrintData[i].TotalAmount.toFixed(2));
          this.PrintData[i].TotalCGST = parseFloat(this.PrintData[i].TotalCGST.toFixed(2));
          this.PrintData[i].TotalSGST = parseFloat(this.PrintData[i].TotalSGST.toFixed(2));
          this.PrintData[i].TotalIGST = parseFloat(this.PrintData[i].TotalIGST.toFixed(2));
          //added by vithujan 13-10-2022
          if (this.TaxApplicableFlag == true) {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount + this.PrintData[i].TotalCGST + this.PrintData[i].TotalSGST + this.PrintData[i].TotalIGST;
          } else {
            this.PrintData[i].NetTotalAmount = this.PrintData[i].TotalAmount;
          }
          //end
          this.PrintData[i].NetTotalAmount = parseFloat(this.PrintData[i].NetTotalAmount.toFixed(2));
          // add kevin 12-Jan-2022
          this.RoundOfAmount = parseFloat((Math.round(this.PrintData[i].NetTotalAmount) - this.PrintData[i].NetTotalAmount).toFixed(2));
          this.PrintData[i].NetTotalAmount = Math.round(this.PrintData[i].NetTotalAmount);
          this.PrintData[i].RoundOffValue = this.RoundOfAmount;
          // end
          // add kevin 02-Mar-2022
          // if (this.PrintData[i].ChargeType == 'Credit Note') {
          //   this.PrintData[i].TotalAmount = this.PrintData[i].TotalAmount * -1;
          //   this.PrintData[i].NetTotalAmount = this.PrintData[i].NetTotalAmount * -1;
          //   this.PrintData[i].TotalCGST = this.PrintData[i].TotalCGST * -1;
          //   this.PrintData[i].TotalSGST = this.PrintData[i].TotalSGST * -1;
          //   this.PrintData[i].TotalIGST = this.PrintData[i].TotalIGST * -1;
          //   this.PrintData[i].RoundOffValue = this.PrintData[i].RoundOffValue * -1;
          // }
          // end
          this.PrintData[i].TotalTaxablevalue = 0;
          this.PrintData[i].ComponentToTalIGST = 0;
          this.PrintData[i].ComponentToTalSGST = 0;
          this.PrintData[i].ComponentToTalCGST = 0;
          this.PrintData[i].ComponentToTalGST = 0;
          if (Type != "AllInOne") {
            this.PrintData[i].ComponentRate.forEach((element) => {
              element.ComponentGST = 0;
              if (this.PrintData[i].IsTaxable != true) {
                element.IntegratedGST = 0;
                element.StateGST = 0;
                element.CentralGST = 0;
                element.IGSTRATE = 0;
                element.SGSTRATE = 0;
                element.CGSTRATE = 0;
              }
              this.PrintData[i].TotalTaxablevalue += element.TaxableValue;
              this.PrintData[i].ComponentToTalIGST += element.IGSTRATE;
              this.PrintData[i].ComponentToTalSGST += element.SGSTRATE;
              this.PrintData[i].ComponentToTalCGST += element.CGSTRATE;
              element.ComponentGST += element.IGSTRATE + element.SGSTRATE + element.CGSTRATE;
              // add kevin 02-Mar-2022
              // if (this.PrintData[i].ChargeType == 'Credit Note') {
              //   element.TaxableValue = element.TaxableValue * -1;
              //   element.IGSTRATE = element.IGSTRATE * -1;
              //   element.SGSTRATE = element.SGSTRATE * -1;
              //   element.CGSTRATE = element.CGSTRATE * -1;
              //   element.ComponentGST = element.ComponentGST * -1;
              //   this.PrintData[i].TotalTaxablevalue = this.PrintData[i].TotalTaxablevalue * -1;
              //   this.PrintData[i].ComponentToTalIGST = this.PrintData[i].ComponentToTalIGST * -1;
              //   this.PrintData[i].ComponentToTalSGST = this.PrintData[i].ComponentToTalSGST * -1;
              //   this.PrintData[i].ComponentToTalCGST = this.PrintData[i].ComponentToTalCGST * -1;
              // }
              // end
            });
            this.PrintData[i].ComponentToTalGST = this.PrintData[i].ComponentToTalIGST + this.PrintData[i].ComponentToTalSGST + this.PrintData[i].ComponentToTalCGST;
          } else {
            this.PrintData[i].TotalDamage = 0;
            this.PrintData[i].TotalShortage = 0;
            this.PrintData[i].TotalSealShort = 0;
            this.PrintData[i].TotalGoodQtyBoxes = 0;
            this.PrintData[i].TotalGoodQtyBottles = 0;
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              //--------------------Bottles---------------------
              let TotalBottles = element.Quantity * 12;
              let TotalGoodBottles = TotalBottles - (element.Damage + element.Shortage + element.SealShort);
              let TotalGoodQuantityBoxes: number = 0;
              TotalGoodQuantityBoxes = TotalGoodBottles % 12;
              element.TotalGoodQuantityBottles = TotalGoodQuantityBoxes;
              //--------------------Boxes-----------------------
              let DamageBoxes = Math.floor(TotalGoodBottles / 12);
              element.TotalGoodQuantityBoxes = DamageBoxes;
              //----------------------Total---------------------
              this.PrintData[i].TotalDamage = this.PrintData[i].TotalDamage + element.Damage;
              this.PrintData[i].TotalShortage = this.PrintData[i].TotalShortage + element.Shortage;
              this.PrintData[i].TotalSealShort = this.PrintData[i].TotalSealShort + element.SealShort;
              this.PrintData[i].TotalGoodQtyBoxes = this.PrintData[i].TotalGoodQtyBoxes + element.TotalGoodQuantityBoxes;
              this.PrintData[i].TotalGoodQtyBottles = this.PrintData[i].TotalGoodQtyBottles + element.TotalGoodQuantityBottles;
            });
          }
          if (Type == "AllInOne") {
            this.PrintData[i].TotalHaltingAmount = 0.0;
            this.PrintData[i].TotalProductQuantity = 0;
            this.PrintData[i].InvoiceDetails.forEach((element) => {
              if (element.Unit == "Day") {
                this.PrintData[i].TotalHaltingAmount =
                  this.PrintData[i].TotalHaltingAmount + element.Amount;
              }
            });
            this.PrintData[i].InvoiceProductDetail.forEach((element) => {
              this.PrintData[i].TotalProductQuantity = this.PrintData[i].TotalProductQuantity + element.Quantity
            });
          }
        }
        if (this.InvoiceType == "Summary" && this.isISAUrl == true) {
          for (var i = 0; i < this.PrintData.length; i++) {
            this.PrintData[i].InvoiceDetails.sort(function (a, b) {
              var ChargedGSTA = a.ChargedGST ? a.ChargedGST : '';
              var ChargedGSTB = b.ChargedGST ? b.ChargedGST : '';
              return ChargedGSTA.localeCompare(ChargedGSTB);
            });

            this.PrintData[i].InvoiceDetailsA = [];
            this.PrintData[i].InvoiceDetailsB = [];
            this.PrintData[i].Charges = [];

            this.PrintData[i].InvoiceDetails.forEach(element => {
              if (element.ChargedGST == 'NA') {
                var isDone: any = false;
                this.PrintData[i].InvoiceDetailsB.forEach(elementD => {
                  if (element.ChargeType == elementD.ChargeType
                    && element.SACCODE == elementD.SACCODE
                    && element.ChargedGST == elementD.ChargedGST
                    && element.ToCity == elementD.ToCity
                    && element.Unit == elementD.Unit
                    && element.Rate == elementD.Rate) {
                    isDone = true;
                    elementD.QuantityA = parseFloat((elementD.QuantityA + element.Quantity).toFixed(2));
                    elementD.DiscountA = parseFloat((elementD.DiscountA + element.Discount).toFixed(2));
                    elementD.AmountA = parseFloat((elementD.AmountA + element.Amount).toFixed(2));
                  }
                });
                if (isDone == false) {
                  var objA: any = {};
                  objA = element;
                  objA.QuantityA = element.Quantity;
                  objA.RateA = element.Rate;
                  objA.DiscountA = element.Discount;
                  objA.AmountA = element.Amount;
                  this.PrintData[i].InvoiceDetailsB.push(objA);
                }
              } else {
                var isDone: any = false;
                this.PrintData[i].InvoiceDetailsA.forEach(elementD => {
                  if (element.ChargeType == elementD.ChargeType
                    && element.SACCODE == elementD.SACCODE
                    && element.ChargedGST == elementD.ChargedGST
                    && element.ToCity == elementD.ToCity
                    && element.Unit == elementD.Unit
                    && element.Rate == elementD.Rate) {
                    isDone = true;
                    elementD.QuantityA = parseFloat((elementD.QuantityA + element.Quantity).toFixed(2));
                    elementD.DiscountA = parseFloat((elementD.DiscountA + element.Discount).toFixed(2));
                    elementD.AmountA = parseFloat((elementD.AmountA + element.Amount).toFixed(2));
                  }
                });
                if (isDone == false) {
                  var objA: any = {};
                  objA = element;
                  objA.QuantityA = element.Quantity;
                  objA.RateA = element.Rate;
                  objA.DiscountA = element.Discount;
                  objA.AmountA = element.Amount;
                  this.PrintData[i].InvoiceDetailsA.push(objA);
                }
              }

              var data = this.PrintData[i].Charges.filter(x => x.Name === element.ChargeType);
              if (data.length <= 0) {
                var obj: any = {};
                obj.Name = element.ChargeType;
                obj.Amount = 0;
                this.PrintData[i].Charges.push(obj);
              }
            });

            this.PrintData[i].Charges.forEach(element => {
              var data = this.PrintData[i].InvoiceDetails.filter(x => x.ChargeType === element.Name);
              if (data.length > 0) {
                var totalAmount = 0;
                for (let index = 0; index < data.length; index++) {
                  totalAmount = (totalAmount + data[index].Amount)
                }
                element.Amount = totalAmount;
              }
            });
          }
        }
        if (this.InvoiceType == "Detail" && this.isISAUrl == true) {
          for (var i = 0; i < this.PrintData.length; i++) {
            this.PrintData[i].InvoiceDetails.sort(function (a, b) {
              var ChargedGSTA = a.ChargedGST ? a.ChargedGST : '';
              var ChargedGSTB = b.ChargedGST ? b.ChargedGST : '';
              return ChargedGSTA.localeCompare(ChargedGSTB);
            });

            this.PrintData[i].InvoiceDetailsA = [];
            this.PrintData[i].InvoiceDetailsB = [];
            this.PrintData[i].Charges = [];

            this.PrintData[i].InvoiceDetails.forEach(element => {
              if (element.ChargedGST == 'NA') {
                this.PrintData[i].InvoiceDetailsB.push(element);
              } else {
                this.PrintData[i].InvoiceDetailsA.push(element);
              }

              var data = this.PrintData[i].Charges.filter(x => x.Name === element.ChargeCode);
              if (data.length <= 0) {
                var obj: any = {};
                obj.Name = element.ChargeCode;
                obj.Amount = 0;
                this.PrintData[i].Charges.push(obj);
              }
            });

            this.PrintData[i].Charges.forEach(element => {
              var data = this.PrintData[i].InvoiceDetails.filter(x => x.ChargeCode === element.Name);
              if (data.length > 0) {
                var totalAmount = 0;
                for (let index = 0; index < data.length; index++) {
                  totalAmount = (totalAmount + data[index].Amount)
                }
                element.Amount = totalAmount;
              }
            });
          }
        }
        if (ToDo == "Print") {
          this.PrintFormatsChild.InvoiceId = this.InvoiceId;
          this.PrintFormatsChild.PrintData = this.PrintData;
          this.PrintFormatsChild.InvoiceType = Type;
          this.PrintFormatsChild.PrintInvoice();
        }
        if (ToDo == "Show") {
          setTimeout(() => {
            if (this.InvoiceType == "Summary") {
              this.isShowPrintSummary = true;
            } else if (this.InvoiceType == "Summary_FixedKM") {
              this.isSummary_FixedKM = true;
            } else if (this.InvoiceType == "Detail") {
              this.isDetail = true;
            } else if (this.InvoiceType == "Detail1") {
              this.isDetail1 = true;
            } else if (this.InvoiceType == "PDF_EInvoice") {
              this.isPDF_EInvoice = true;
            } else if (this.InvoiceType == "Detail1OnLatterPad") {
              this.isDetail1OnLatterPad = true;
            } else if (this.InvoiceType == "OnLatterPad_EInvoice") {
              this.isOnLatterPad_EInvoice = true;
            } else if (this.InvoiceType == "Detail_KM_MT") {
              this.isDetail_KM_MT = true;
            } else if (this.InvoiceType == "PrintInvoiceKSHSummary") {
              this.isPrintInvoiceKSHSummary = true;
            }
            else if (this.InvoiceType == "PrintInvoiceInfinity") {
              this.PrintInvoiceInfinity = true;
            }
            else {
              this.isUBInvoice = true;
            }

            setTimeout(() => {
              if (this.invoiceBody) {
                this.invoiceHtml = this.invoiceBody.nativeElement.innerHTML;
                this.getInvoiceConsignmentPODList();
                console.log(this.invoiceHtml);
              }
            }, 5000);
          }, 500);
          Helpers.setLoading(false);
        }
        this.GetOutstandingStatement();
      },
        (err) => {
          Helpers.setLoading(false);
          $("#PrintInvoice").val("");
          this.toastr.error("An error occured printing !", "error");
        }
      );
    }
  }

  UpdateIsViewed(id: any) {
    var apiUrl = environment.apiUrl + "api/Sales/UpdateInvoiceViewed/" + id;

    this.http.get(apiUrl).subscribe(
      (response) => {

      },
      (err) => {
        console.log(err);
        console.log("Error occured");
      }
    );
  }

  onClick(type: any) {
    this.selectedOption = type;
    if (type == 'Invoice') {
      this.isShowInvoice = true;
      this.isShowPaymentMade = false;
    } else if (type == 'PaymentMade') {
      this.isShowInvoice = false;
      this.isShowPaymentMade = true;
    }
  }

  GetPaymentSummaryData() {
    if (this.InvoiceId != null && this.InvoiceId != undefined) {
      Helpers.setLoading(true);

      var apiUrl = environment.apiUrl + "api/Sales/GetPaymentReceiptSummary/" + this.InvoiceId;

      this.http.get(apiUrl).subscribe(
        (response) => {
          this.ReceiptSummaryData = response;
        },
        (err) => {
          this.toastr.error("An error occured  !", "error");
        }
      );
      Helpers.setLoading(false);
    }
  }

  onClickSidebar() {
    if (window.screen.width <= 480) {
      document.getElementById('sidebar').style.display = "block";
      document.getElementById('menubar').style.display = "none";
    }
  }

  onCloseSidebar() {
    if (window.screen.width <= 480) {
      document.getElementById('sidebar').style.display = "none";
      document.getElementById('menubar').style.display = "block";
    }
  }

  getInvoiceConsignmentPODList() {
    Helpers.setLoading(true);
    this.invPodListData = [];
    var PdfConsignmentNo = [];
    this._appService.GetByTwoId("Sales", "pi_getInvoiceConsignmentPODList", this.InvoiceId, this.CompanyId).subscribe((response) => {
      response.forEach(element => {
        if (element.FileExtension != 'pdf') {
          element.OrgFileName = 'POD_' + element.consignmentNo.replace(/[^a-zA-Z0-9]/g, "") + '.' + element.FileExtension;
          this.invPodListData.push(element);
        } else {
          PdfConsignmentNo.push(element.consignmentNo);
        }
      });
      this.getMergePdf(PdfConsignmentNo);
      Helpers.setLoading(false);
    },
      (err) => {
        console.log('log', err);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
        Helpers.setLoading(false);
      });
  }

  minifyHtml(html: string): string {
    if (!html) return '';
    
    // Remove extra whitespace between tags and inside tags (replaces sequences of spaces and newlines with a single space)
    html = html.replace(/\s+/g, ' ');

    // Remove spaces between HTML tags
    html = html.replace(/\s*([<>])\s*/g, '$1');

    // Remove leading and trailing spaces
    html = html.trim();

    return html;
  }

  MergedPdfResponse: any;
  getMergePdf(PdfConsignmentNo) {
    Helpers.setLoading(true);

    var obj: any={};
    obj.InvoiceId = this.InvoiceId;
    obj.CompanyId = this.CompanyId;
    obj.HtmlData = (this.invoiceHtml) ? this.minifyHtml(this.invoiceHtml.trim()) : null;
    console.log('obj.HtmlData', obj.HtmlData);
    this._appService.Post("Sales", "pi_getInvoiceConsignmentPODPdfList", obj).subscribe((response) => {
      if (response != null) {
        this.MergedPdfResponse = response;
        const uniqueNames = Array.from(new Set(PdfConsignmentNo));
        const result = uniqueNames.join(',');

        var obj: any = {};
        obj.consignmentNo = result;
        obj.OrgFileName = 'POD_' + result.replace(/[^a-zA-Z0-9]/g, "") + '.pdf';
        obj.FileExtension = 'pdf';
        this.invPodListData.push(obj);
      }
      Helpers.setLoading(false);
    },
      (err) => {
        console.log('log', err);
        this.toastr.error(err._body.replace(/"/g, ""), "Error");
        Helpers.setLoading(false);
      });
  }

  DownloadSelectedPodFile(index, filePath, fileExtension, consignmentNo) {
    if (fileExtension != 'pdf') {
      var path1 = environment.apiUrl + filePath;
      consignmentNo = 'POD_' + consignmentNo.replace(/[^a-zA-Z0-9]/g, "");
      this._appService.GetByThreeId("Sales", "pi_downloadPODFile", filePath, fileExtension, consignmentNo).subscribe((response) => {
        Helpers.setLoading(false);
        this.DownloadFile(response);
      },
        (err) => {
          Helpers.setLoading(false);
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
        }
      );
    } else {
      this.DownloadFile(this.MergedPdfResponse);
    }
    // window.open(path1, "");
  }

  DownloadFile(FileContent) {
    var byteNumbers = new Array(FileContent.Content.length);
    for (var i = 0; i < FileContent.Content.length; i++) {
      byteNumbers[i] = FileContent.Content.charCodeAt(i);
    }
    var blob = this.commonService.b64toBlob(
      FileContent.Content,
      FileContent.ContentType
    );
    let url = window.URL.createObjectURL(blob);
    $("#DownLoadFileSalesReport").attr("href", url);
    $("#DownLoadFileSalesReport").attr("download", FileContent.FileName);
    let element: HTMLElement = document.getElementById("DownLoadFileSalesReport") as HTMLElement;
    element.attributes;
    element.click();
  }

  GetOutstandingStatement() {
    if (this.IsOutstandingStatement == 'True') {
      Helpers.setLoading(true);
      this._appService.GetByFiveId("AccountingReport", "rp_GetDebtorsStatement", this.PrintData[0].CompanyId, 'Debit', this.PrintData[0].CustomerId, null, false).subscribe((response) => {
        this.OutstandingData = response;
        this.CalculateDebtorsStamentTotal();
        Helpers.setLoading(false);
      },
        (err) => {
          this.toastr.error(err._body.replace(/"/g, ""), "Error");
          Helpers.setLoading(false);
        });
    }
  }

  CalculateDebtorsStamentTotal() {
    this.TotalInvoiceAmount = 0;
    this.TotalReceiptAmount = 0;
    this.TotalClosingBalance = 0;
    var amountDiff = 0;
    this.OutstandingData.forEach((element) => {
      this.TotalInvoiceAmount = this.TotalInvoiceAmount + element.InvoiceAmount;
      this.TotalReceiptAmount = this.TotalReceiptAmount + element.ReceiptAmount;
      amountDiff = amountDiff + element.InvoiceAmount - element.ReceiptAmount;
      element.ClosingBalance = amountDiff;
      // if (this.ShowAllTransactions == true) {
      //   element.ClosingBalance = amountDiff;
      // } else {
      element.ClosingBalance = element.InvoiceAmount - element.ReceiptAmount;
      // }
    });
    this.TotalClosingBalance = this.TotalInvoiceAmount - this.TotalReceiptAmount;
  }

  GetWhiteLabelSettingVal() {
    this._appService.GetById("Common", "GetSystemSettingByName", "WhiteLabel").subscribe((response) => {
      if (response == "1") {
        this.whitelabelFlag = true;
      } else {
        this.whitelabelFlag = false;
      }
    },
      (err) => {
        this.toastr.error(err._body.replace(/"/g, ""), "error");
      });
  }

  //added by vithujan 31-08-2023
  PrintQuoteData: any = [];
  GetOrderData(Id) {
    this._appService
      .GetByTwoId(
        "OrdersByVehicle",
        "GetOrderVehicleById",
        Id,
        null
      )
      .subscribe(
        (response) => {
          //OrderComponent.orderComponent.model = response;
          this.PrintQuoteData.push(response);
          this.QuoteNo = this.PrintQuoteData[0].OrderNo;
        },
        (err) => {
          this.toastr.error(
            "An erro occured while Update Data",
            "ChargeType"
          );
        }
      );
  }

  TotalAmount: any = 0;
  TotalAdvance: any = 0;
  TotalBalance: any = 0;
  ShowQuoteData(Id) {
    this.TotalAmount = 0;
    this.TotalAdvance = 0;
    this.TotalBalance = 0;

    this.QuoteCompanyData = {};
    this.QuoteUserData = {};

    this._appService.GetById("byVehicleIncome", "GetChargeListByIndentId", Id).subscribe((res) => {
      res.forEach(element => {
        this.InvoiceData.push(element);
        this.TotalAmount = (this.TotalAmount + element.Amount);
        this.TotalAdvance = (this.TotalAdvance + element.Advance);
        this.TotalBalance = this.TotalAmount - this.TotalAdvance;
      });
    }, (err) => {
      console.log("Error", err);
    });

    this._appService.GetById("OrdersByVehicle", "GetCompanyForQuote", this.PrintQuoteData[0].CreatedBy).subscribe((res) => {
      this.QuoteCompanyData = res.Table[0];
      this.QuoteUserData = res.Table1[0];
      console.log('this.QuoteCompanyData', this.QuoteCompanyData);
    }, (err) => {
      console.log("Error", err);
    });
  }

  GetUserCompanyByOrder(id: string) {

    // var apiUrl = environment.apiUrl + "api/Company/GetUserCompanyDataByInvoice/" + id;
    var apiUrl = environment.apiUrl + "api/Company/GetUserCompanyDataByInvoice?id=" + id + "&param1=OrderId";
    this.http.get(apiUrl).subscribe(
      (response: any) => {
        this.TenantUsers = response.data;
        this.TenantUsers.forEach((element) => {
          this.CompanyIdForCookie = element;
          this.CompanyId = this.CompanyIdForCookie.Id;
          this.SelectedComapnyName = this.CompanyIdForCookie.SelectedComapnyName;
          this.SelectedCompanyAdd = this.CompanyIdForCookie.SelectedCompanyAdd;
          this.SelectedCompanyCIN = this.CompanyIdForCookie.SelectedCompanyCIN;
          this.SelectedCompantGSTIN = this.CompanyIdForCookie.SelectedCompantGSTIN;
          this.SelectedCompanyLogo = this.CompanyIdForCookie.CompanyLogoPath;
          this.SelectedCompanyPAN = this.CompanyIdForCookie.SelectedCompanyPAN;
          this.SelectedCompantEmail = this.CompanyIdForCookie.SelectedComapnyEmail;
          this.SelectedCompanyWebsite = this.CompanyIdForCookie.Website;
          this.imgPath = environment.apiUrl + this.SelectedCompanyLogo;
          this.SelectedCompanyLogoImg = environment.apiUrl + this.SelectedCompanyLogo;
        });
      },
      (err) => {
        console.log(err);
        console.log("Error occured");
      }
    );
  }

  PrintQuote() {
    this.PrintFormatsChild.PrintQuoteData = [];
    this.PrintFormatsChild.PrintQuoteData = this.PrintQuoteData;
    this.PrintFormatsChild.InvoiceType = 'PrintQuote';
    this.PrintFormatsChild.UserId = this.PrintQuoteData[0].CreatedBy;
    this.PrintFormatsChild.CompId = this.CompanyId;
    this.PrintFormatsChild.PrintInvoice();
  }

}
